import { gql } from "@apollo/client";
export const OUT_OF_OFFICE_UPDATED = gql`
  subscription OutOfOfficeUpdated {
    outOfOfficeUpdated {
      outOfOffices {
        comments
        fromDate
        outOfOfficeReplacementId
        replaced
        replacedUserId
        replacement
        replacementUserId
        toDate
      }
    }
  }
`;
